import React from 'react'
import { PDFViewer } from '@react-pdf/renderer'
import InvoicePdf from '../../features/Inventory/ManageInvoiceUI/InvoicePdf'
import { useLocation } from 'react-router-dom'
import CrmInvoicePdf from '../../features/Crm/CrmManageInvoiceUI/CrmInvoicePdf'

export const CrmViewInvoice = () => {
    const location = useLocation()
    return (
        <div className=' w-full h-[900px]'>
            <PDFViewer width="100%" height="100%">
                <CrmInvoicePdf data={location.state.data} />
            </PDFViewer>
        </div>
    )
}
